import { useState, useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";
import { logError } from "@/lib/errorHandler";

export const usePartner = () => {
  const { user } = useAuth();
  const [isPartner, setIsPartner] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setIsPartner(false);
      setLoading(false);
      return;
    }

    const checkRole = async () => {
      try {
        const { data, error } = await supabase
          .from("user_roles")
          .select("role")
          .eq("user_id", user.id)
          .eq("role", "partner" as any)
          .maybeSingle();

        if (error) {
          logError("partner-role-check", error);
          setIsPartner(false);
        } else {
          setIsPartner(!!data);
        }
      } catch (err) {
        logError("partner-check", err);
        setIsPartner(false);
      } finally {
        setLoading(false);
      }
    };

    checkRole();
  }, [user]);

  return { isPartner, loading };
};
